import _TabMenu from 'components/Legacy/Tabs/TabMenu'
import borderRadius from 'polished/lib/shorthands/borderRadius'
import styled from 'styled-components'
import { color } from 'utils'

const TabMenu = styled(_TabMenu)`
  ${borderRadius('top', '3px')};
  border: solid 2px ${color('whiteAlpha10')};

  & > div {
    justify-content: flex-start;
  }
`

export default TabMenu
